/**
 * Horizon overrides for Shopify.actions:
 * - updateCart: emit events from the cart drawer scope.
 * - openCart: open the cart drawer (fall back to /cart when absent).
 *
 * The cart drawer is `c-cart-drawer`, not Horizon's own, so both actions route
 * through `window.FM.cart`. Horizon's `theme-drawer#cart-drawer` is no longer
 * rendered; anything still calling these actions would otherwise bounce the
 * customer to /cart.
 */

function init() {
  const actions = window.Shopify?.actions;
  if (!actions) return;

  actions.updateCart.configure({
    eventTarget: () => document.querySelector('[data-c-cart]') ?? document,
  });

  actions.openCart.configure({
    async handler() {
      const cart = window.FM?.cart;

      if (cart) {
        await cart.refresh();
        cart.open();
      } else {
        window.location.href = Theme.routes.cart_url || '/cart';
      }
    },
  });
}

// Run immediately if the standard-actions bundle has already attached
// `Shopify.actions`; otherwise wait for DOMContentLoaded, which fires after
// all module scripts have executed regardless of document order.
if (window.Shopify?.actions) {
  init();
} else {
  document.addEventListener('DOMContentLoaded', init, { once: true });
}
